import { render, staticRenderFns } from "./TeamLogo.vue?vue&type=template&id=d6a56ba2&"
import script from "./TeamLogo.vue?vue&type=script&lang=js&"
export * from "./TeamLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports